module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-wrapper"
  }, [_c('form', {
    attrs: {
      "action": "#"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm(_vm.endpoint)
      }
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.formHeader))]), _vm._t("default"), _c('ed-button', {
    class: _vm.submitClass,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.submitText))])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef869d8e","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edForm/index.vue
// module id = 3xOL
// module chunks = 13 14